// extracted by mini-css-extract-plugin
export default {"auth-button":"ButtonWrapper--auth-button--7vRBM","authButton":"ButtonWrapper--auth-button--7vRBM"};